import { CircuitNode } from "./CircuitNode";
import { CircuitBackground } from "./CircuitBackground";

const events = [
  {
    id: 1,
    title: "RAPID CODING",
    date: "2026.01.23",
    time: "10:00 HRS",
    venue: "IT 443",
    description: "Indulge in a fierce round of coding and bag a gold coin",
    color: "#ff0055",
  },
  {
    id: 2,
    title: "PAPER PRESENTATION",
    date: "2026.01.23",
    time: "10:00 HRS",
    venue: "MULTIPLE VENUES",
    description: "Showcase of innovative scientific ideas",
    color: "#00ff88",
  },
  {
    id: 3,
    title: "TECHNICAL QUIZ",
    date: "2026.01.23",
    time: "12:00 HRS",
    venue: "AUDITORIUM",
    description: "Multiple rounds of intense technical test for the brain.",
    color: "#00ccff",
  },
  {
    id: 4,
    title: "LOGIC & PUZZLE CODING",
    date: "2026.01.23",
    time: "12:30 HRS",
    venue: "TECH_HUB",
    description: "Put your brain to the ultimate test by solving code puzzles",
    color: "#ffaa00",
  },
  {
    id: 5,
    title: "ANIME QUIZ",
    date: "2026.01.23",
    time: "11:30 HRS",
    venue: "IT 444",
    description: "Prove you are a die hard fan!",
    color: "#aa00ff",
  },
  {
    id: 6,
    title: "IPL AUCTION",
    date: "2026.01.23",
    time: "13:00 HRS",
    venue: "LBCH",
    description: "Build your own team and win the game",
    color: "#ff6600",
  },
  {
    id: 7,
    title: "SQUID GAME",
    date: "2026.01.23",
    time: "14:00 HRS",
    venue: "IT 207",
    description: "Indulgen in Fun and Frolic",
    color: "#00ffcc",
  },
  {
    id: 8,
    title: "CARROM",
    date: "2026.01.23",
    time: "15:00 HRS",
    venue: "IT 207",
    description: "Are you really the carrom king?",
    color: "#ff00aa",
  },
  {
    id: 9,
    title: "BLIND CODING",
    date: "2026.01.23",
    time: "14:30 HRS",
    venue: "IT 442",
    description: "Believe your instincts not your senses",
    color: "#00aaff",
  },
  {
    id: 10,
    title: "HACKATHON",
    date: "2026.01.24",
    time: "10:00 HRS",
    venue: "LBCH",
    description: "Display your Projects",
    color: "#ffff00",
  },
  {
    id: 11,
    title: "CODE GOLF",
    date: "2026.01.24",
    time: "09:30 HRS",
    venue: "IT 442",
    description: "Write the shortest code possible",
    color: "#ffff00",
  },
  {
    id: 12,
    title: "CODE HUNT",
    date: "2026.01.24",
    time: "11:00 HRS",
    venue: "IT 215",
    description: "Treasure hunt with coding challenges",
    color: "#ffff00",
  },
  {
    id: 13,
    title: "MOVIES MANIA",
    date: "2026.01.24",
    time: "11:00 HRS",
    venue: "IT 444",
    description: "Prove you are a hardcore cine fan",
    color: "#ffff00",
  },
  {
    id: 14,
    title: "SEMINAR",
    date: "2026.01.24",
    time: "10:00 HRS",
    venue: "IT 213",
    description: "Learn Something new with our Experts",
    color: "#ffff00",
  },
  {
    id: 15,
    title: "TIK TIK TIK",
    date: "2026.01.24",
    time: "10:30 HRS",
    venue: "IT 443",
    description: "The clocks ticking can you answer all the questions",
    color: "#ffff00",
  },
  {
    id: 16,
    title: "RELAY CODING",
    date: "2026.01.24",
    time: "14:00 HRS",
    venue: "IT 442",
    description: "Team coding relay challenge",
    color: "#ffff00",
  },
  {
    id: 17,
    title: "ESCAPE ROOM",
    date: "2026.01.24",
    time: "13:30 HRS",
    venue: "PUZZLE ROOM",
    description: "Are you Sherlock Holmes",
    color: "#ffff00",
  },
  {
    id: 18,
    title: "WORKSHOP",
    date: "2026.01.24",
    time: "14:00 HRS",
    venue: "IT 444",
    description: "Learn Something new with our Experts",
    color: "#ffff00",
  },
  {
    id: 19,
    title: "TREASURE HUNT",
    date: "2026.01.24",
    time: "15:00 HRS",
    venue: "CIT CAMPUS",
    description: "Grab the Gold coin",
    color: "#ffff00",
  },
];

export const CircuitTimeline = () => {
  return (
    <div className="relative w-full min-h-screen bg-black overflow-hidden py-20">
      <CircuitBackground />

      {/* Title */}
      <div className="relative z-20 text-center mb-16">
        <div className="inline-block">
          <h1 className="text-5xl md:text-6xl font-mono font-bold tracking-wider mb-2 animate-glitch">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-purple-500 to-pink-500">
              CHRONOLINE
            </span>
          </h1>
          <div className="h-0.5 bg-gradient-to-r from-transparent via-cyan-500 to-transparent" />
          <p className="text-cyan-500/60 text-sm font-mono tracking-[0.3em] mt-3">
            {'\u002F\u002F SYSTEM.EVENTS.LOAD()'}
          </p>
        </div>
      </div>

      {/* Timeline */}
      <div className="relative max-w-6xl mx-auto px-8">
        {/* Center line */}
        <div className="absolute left-1/2 top-0 bottom-0 w-1 -translate-x-1/2">
          <div className="w-full h-full bg-gradient-to-b from-cyan-500/50 via-purple-500/50 to-pink-500/50" />
          <div className="absolute inset-0 w-full bg-gradient-to-b from-cyan-500 via-purple-500 to-pink-500 animate-pulse-slow opacity-50" />
        </div>

        {/* Events - Show all events */}
        <div className="relative space-y-16">
          {events.map((event, index) => (
            <div
              key={event.id}
              className={`flex ${index % 2 === 0 ? "justify-start" : "justify-end"}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <CircuitNode event={event} index={index} isLeft={index % 2 === 0} />
            </div>
          ))}
        </div>

        {/* End node */}
        <div className="absolute left-1/2 bottom-0 -translate-x-1/2 translate-y-1/2">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-cyan-500 to-purple-500 flex items-center justify-center">
            <div className="w-4 h-4 rounded-full bg-black" />
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="relative z-20 text-center mt-20">
        <p className="text-cyan-500/40 font-mono text-xs tracking-widest">
          [ HOVER TO ACTIVATE NODES ]
        </p>
      </div>

      <style >{`
        .animate-glitch {
          animation: glitch 5s infinite;
        }
        
        .animate-pulse-slow {
          animation: pulse 4s ease-in-out infinite;
        }
        
        @keyframes glitch {
          0%, 100% {
            transform: translate(0);
          }
          1% {
            transform: translate(-2px, 2px);
          }
          2% {
            transform: translate(-2px, -2px);
          }
          3% {
            transform: translate(2px, 2px);
          }
          4% {
            transform: translate(2px, -2px);
          }
          5% {
            transform: translate(0);
          }
        }
        
        @keyframes pulse {
          0%, 100% {
            opacity: 0.5;
          }
          50% {
            opacity: 0.8;
          }
        }
      `}</style>
    </div>
  );
};